"use client";
import { useState, useRef, useEffect } from "react";
import dynamic from "next/dynamic";

const WebStory = dynamic(() => import("./WebStory"), {
  ssr: false,
});

export default function LazyWebStory(props) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: "200px" },
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} style={{ minHeight: 200 }}>
      {isVisible && <WebStory {...props} />}
    </div>
  );
}
